import { BizCheckBox } from '../../Mini/BizCheckBox';
import { FormFieldComponentProps } from './fieldProps';

const CheckboxField = ({ field, value, disabled, onChange, onBlur }: FormFieldComponentProps) => {
	const description = field.settings.description as string | undefined;
	const checked = value === 'true';

	return (
		<div onBlur={onBlur}>
			<BizCheckBox
				value={checked}
				onChange={(checked) => onChange(String(checked))}
				label={field.label}
				description={description}
				disabled={disabled}
			/>
		</div>
	);
};

export default CheckboxField;
